/**
 * Calendario Feature React Query Hooks
 */

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/lib/useAuth';
import * as api from '@/api/queries/calendario';
import type { CalendarioEvento, StrutturaCalendario } from './types';

const QUERY_KEY = 'calendario';

// ============================================================
// QUERIES
// ============================================================

export function useCalendario(options?: { 
  mese?: number; 
  anno?: number; 
  strutturaId?: string;
}) {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: [QUERY_KEY, 'eventi', user?.id, options?.mese, options?.anno, options?.strutturaId],
    queryFn: async () => {
      const { data, error } = await api.getCalendarioEventi({
        userId: user?.id,
        mese: options?.mese,
        anno: options?.anno,
        strutturaId: options?.strutturaId,
      });
      if (error) throw error;
      return (data || []) as CalendarioEvento[];
    },
    enabled: !!user?.id,
  });
}

export function useStruttureCalendario() {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: [QUERY_KEY, 'strutture', user?.id],
    queryFn: async () => {
      const { data, error } = await api.getStruttureCalendario({ userId: user?.id });
      if (error) throw error;
      return (data || []) as StrutturaCalendario[];
    },
    enabled: !!user?.id,
  });
}

export function useCalendarioEventi() {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: [QUERY_KEY, 'eventi-tutti', user?.id],
    queryFn: async () => {
      const { data, error } = await api.getCalendarioEventi({ userId: user?.id });
      if (error) throw error;
      return (data || []) as CalendarioEvento[];
    },
    enabled: !!user?.id,
  });
}
